import { cn } from "@/libraries/cn";
import { forwardRef } from "react";

interface CheckBoxCircleProps extends React.ComponentProps<"input"> {
	label?: string;
	labelClassName?: React.ComponentProps<"label">["className"];
}

const CheckBoxCircle = forwardRef<HTMLInputElement, CheckBoxCircleProps>(
	(props, ref) => {
		const { label, hidden, labelClassName, ...inputProps } = props;
		return (
			<label
				className={cn(
					"group relative max-w-fit inline-flex items-center justify-start cursor-pointer tap-highlight-transparent p-2 -m-2 select-none",
					{
						hidden,
					},
					labelClassName,
				)}
				data-selected={inputProps.checked}
			>
				<span className="sr-only">
					<input
						ref={ref}
						aria-label={label}
						aria-labelledby=":r5g:"
						type="checkbox"
						{...inputProps}
					/>
				</span>
				<span
					aria-hidden="true"
					className="relative inline-flex items-center justify-center flex-shrink-0 overflow-hidden before:content-[''] before:absolute before:inset-0 before:border-solid before:border-2 before:box-border before:border-default after:content-[''] after:absolute after:inset-0 after:scale-50 after:opacity-0 after:origin-center group-data-[selected=true]:after:scale-100 group-data-[selected=true]:after:opacity-100 group-data-[hover=true]:before:bg-default-100 outline-none group-data-[focus-visible=true]:z-10 group-data-[focus-visible=true]:ring-2 group-data-[focus-visible=true]:ring-focus group-data-[focus-visible=true]:ring-offset-2 group-data-[focus-visible=true]:ring-offset-background after:bg-primary after:text-primary-foreground text-primary-foreground w-5 h-5 mr-2 rtl:ml-2 rtl:mr-[unset] rounded-full before:rounded-full after:rounded-full before:transition-colors group-data-[pressed=true]:scale-95 transition-transform after:transition-transform-opacity after:!ease-linear after:!duration-200 motion-reduce:transition-none group-data-[selected=true]:text-white"
				>
					<svg
						aria-hidden="true"
						role="presentation"
						viewBox="0 0 17 18"
						className="z-10 opacity-0 group-data-[selected=true]:opacity-100 w-4 h-3 transition-opacity motion-reduce:transition-none"
					>
						<polyline
							fill="none"
							points="1 9 7 14 15 4"
							stroke="currentColor"
							strokeDasharray={22}
							strokeDashoffset={44}
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
						/>
					</svg>
				</span>
				{label ? (
					<span
						id=":r5g:"
						className="relative text-foreground select-none text-medium transition-colors-opacity before:transition-width motion-reduce:transition-none"
					>
						{label}
					</span>
				) : null}
			</label>
		);
	},
);

export default CheckBoxCircle;
